import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    serviceRequest_number: 'Номер заявки',
    serviceRequest_status: 'Статус заявки',
    serviceRequest_processing_result: 'Результат обработки',
    serviceRequest_date: 'Дата заявки',
    serviceRequest_iin: 'ИИН заявителя',
    serviceRequest_PEP_number: 'Номер заявки ПЭП',
    serviceRequest_providerId: 'Номер услугодателя',
    serviceRequest_providerBin: 'БИН услугодателя',
    serviceRequest_serviceProvider: 'Услугодатель',
    serviceRequest_chooseServiceProvider: 'Выбрать',
    gbdflButton_searchFailed: 'Ошибка сервера',
    serviceRequest_linkText: 'Алгоритм пилотного проекта',

    gbdflButton_iinNotFound:
      'Данных по введенному ИИН не найдены в Государственной базе данных физических лиц, проверьте корректность ввода ИИН или обратитесь в государственный орган.',
    gbdflButton_iinNotFound_2:
      'В Государственной базе данных физических лиц данные не найдены. Проверьте корректность ввода ИИН или приложите подтверждающий документ.',
    gbdflButton_iinNotFound_3:
      'По указанному ИИН ребенка в системе не были найдены данные по выданному направлению в дошкольную организацию. Вам необходимо в личном кабинете получить «Направление» в дошкольную организацию',
    gbdflButton_iinNotFound_in_voucher_3:
      'По указанному ИИН ребенка в системе не были найдены данные по выданному ваучер в дошкольную организацию. Вам необходимо дождаться очереди и получить ваучер в личном кабинете',
    gbdflButton_iinNotFound_4:
      'По данному ИИН ребенка направление в дошкольную организацию было получено другим Заявителем. Необходимо подать заявление на зачисление ребенка от Заявителя, который получил направление в дошкольную организацию.',
    gbdflButton_iinNotFound_5:
      'Данные не найдены. Проверьте корректность ввода ИИН или заполните все обязательные поля.',
    gbdflButton_binNotFound: 'Данных по запрашиваемому БИН не найдены',
    gbdflButton_search: 'Запрос данных',
    serviceRequest_onbeforunload: 'Вы хотите покинуть страницу?',
    serviceRequest_fillChildIin: 'Необходимо заполнить ИИН ребенка!',
    serviceRequest_mustBeSixYearsOld:
      'Возраст ребенка должен быть 6 лет на конец текущего года',
    serviceRequest_alreadyStudy:
      'Поступающий числится в организации образования {{schoolName}}, воспользуйтесь типом заявления "Прием документов для перевода детей между организациями начального, основного среднего, общего среднего образования"',
    serviceRequest_po: 'Дошкольные организации',
    serviceRequest_leb: 'Местный исполнительный орган',
    serviceRequest_otve: 'Организации технического и профессионального образования',
    serviceRequest_seo: 'Организации среднего образования',
    serviceRequest_selectDDO: 'Выбрать',
    serviceRequest_listChildren: 'Список детей',
    serviceRequest_zagsTokensExpired:
      'Ваши данные устарели. Пожалуйста, пройдите интеграцию повторно.',
    serviceRequest_zagsIntegrationRetry:
      'Данные успешно получены. Теперь вы можете снова выполнить поиск ребёнка.',
    serviceProviders_fioChild: 'ФИО ребенка',
    serviceRequest_checkContingent:'Заявка принята.',
    serviceRequest_checkContingentMessage:'Обработка заявки начнется после выбытия с текущего садика или 5 рабочих дней.',
    serviceRequest_checkContingentOkButton:'Хорошо',


    serviceRequestDucks_saveSuccess: 'Ваша заявка успешно подписана',
    serviceRequestDucks_signCanceled: 'Подпись заявки отменена',
    serviceRequestDucks_saveFailed: 'Не удалось подписать заявку',
    serviceRequestDucks_loadDataFailed: 'Не удалось загрузить данные',
    serviceRequestDucks_requestFailed:
      'Данная услуга недоступна для вашего региона. Пожалуйста, выберите доступную услугу для получения ваучера.',
    serviceRequest_age_error:
      'В связи с достижением возраста ребенка 6 лет в текущем учебном году получение услуги невозможно',
    serviceRequest_queue_type_check_req_err:
      'Ошибка запроса проверки иин ребенка в очереди',
    serviceRequest_check_in_queue_err1:
      'Оказание государственной услуги невозможно, т.к. ранее по {{fio}}, ИИН {{child_iin}} подано заявление №{{req_form_id}} (статус "{{app_status}}").',
    serviceRequest_check_in_queue_err2:
      'Оказание государственной услуги невозможно, т.к. {{fio}}, ИИН {{child_iin}} по заявлению №{{req_form_id}} стоит в очереди (тип очереди – {{queued_type}}, приоритетность в очереди – {{priority_queued}}).',
    serviceRequest_check_in_queue_err3:
      'Оказание государственной услуги невозможно, т.к. {{fio}}, ИИН {{child_iin}} по заявлению №{{req_form_id}} получил(-а) направление №{{dir_id}} действующее сроком до {{dir_date}} г.',
    serviceRequest_check_in_queue_err4:
      'Оказание государственной услуги невозможно, т.к. заявление № {{req_form_id}} находится в стоп-листе сроком до {{deadline_stop_list}} г. После завершения указанного срока {{fio}}, ИИН {{child_iin}} будет восстановлен(-а) в очередь.',
    serviceRequest_check_in_queue_err5:
      'Оказание государственной услуги невозможно, т.к. {{fio}}, ИИН {{child_iin}} по заявлению №{{req_form_id}} был представлен ваучер.',
    serviceRequest_check_in_queue_err6:
      'Оказание государственной услуги невозможно, т.к. {{fio}}, ИИН {{child_iin}}, по заявлению № {{req_form_id}} получил(-а) ваучер № {{id}}',
    serviceRequest_check_in_queue_err7:
        'Оказание государственной услуги невозможно, т.к. {{fio}}, ИИН {{child_iin}} получил(-а) ваучер по заявлению № {{req_form_id}}',

    childInformationButton_iinNotFound:
      'Данные не найдены. Проверьте корректность ввода ИИН или заполните все обязательные поля и приложите сканированный документ свидетельства о рождении.',
    childInformationButton_arrivedDO:
      'Оказание государственной услуги невозможно, т.к. {{fio}}, {{child_iin}} получил направление',
    childInformationButton_enrolledDO:
      'Оказание государственной услуги невозможно, т.к. {{fio}}, {{child_iin}} зачислен в дошкольную организацию',

    serviceRequest_supplierApplicationRequestAlreadyExists:'У Поставщика уже есть активное заявление',

    serviceRequest_requesterApplicationRequestAlreadyExists:'У заявителя уже есть активное заявление',
  },
  kk: {
    serviceRequest_number: 'Өтінім нөмірі',
    serviceRequest_status: 'Өтінім мәртебесі',
    serviceRequest_processing_result: 'Өңдеу нәтижесі',
    serviceRequest_date: 'Өтінім күні',
    serviceRequest_iin: 'Өтінім берушінің ЖСН',
    serviceRequest_PEP_number: 'ПЭП өтінім нөмірі',
    serviceRequest_providerId: 'Қызмет көрсетуші нөмірі',
    serviceRequest_providerBin: 'Қызмет көрсетушінің БСН',
    serviceRequest_serviceProvider: 'Қызмет көрсетуші',
    gbdflButton_search: 'Деректерді сұрату',
    serviceRequest_chooseServiceProvider: 'Таңдау',
    serviceRequest_po: 'Мектепке дейінгі ұйымдар',
    serviceRequest_leb: 'Жергілікті атқарушы орган',
    serviceRequest_seo: 'Орта білім беру ұйымдары',
    serviceRequestDucks_signCanceled: 'Өтінімге қол қою жойылды',
    serviceRequestDucks_saveFailed: 'Өтінімге қол қою сәтсіз аяқталды',
    serviceRequestDucks_loadDataFailed: 'Деректерді жүктеу сәтсіз аяқталды',
    serviceRequest_otve: 'Техникалық және кәсіптік білім беру ұйымдары',
    serviceRequest_selectDDO: 'Таңдау',
    serviceRequest_linkText: 'Пилоттық жобаның алгоритмі',
    serviceRequest_listChildren: 'Балалар тізімі',
    serviceRequest_zagsTokensExpired:
      'Сіздің деректеріңіз ескірген. Интеграциядан қайта өтіңіз.',
    serviceRequest_zagsIntegrationRetry:
      'Деректер сәтті алынды. Енді баланы қайта іздей аласыз.',
    serviceProviders_fioChild: 'Баланың аты-жөні',
    serviceRequest_checkContingent:'Өтініш қабылданды.',
    serviceRequest_checkContingentMessage:'Өтінішті өңдеу қазіргі балабақшадан шығудан кейін немесе 5 жұмыс күнінен соң басталады.',
    serviceRequest_checkContingentOkButton:'Жақсы',

    //error
    gbdflButton_searchFailed: 'Сервер қатесі',
    gbdflButton_iinNotFound:
      'Енгізілген ЖСН бойынша деректер Жеке тұлғалардың мемлекеттік деректер базасында табылған жоқ, ЖСН дұрыс енгізілгеніне көз жеткізіңіз немесе мемлекеттік органға жүгініңіз.',
    gbdflButton_iinNotFound_2:
      'Жеке тұлғалардың мемлекеттік деректер базасында деректер табылған жоқ. ЖСН дұрыс енгізілгеніне көз жеткізіңіз немесе растайтын құжатты тіркеңіз',
    gbdflButton_iinNotFound_3:
      'Баланың көрсетілген ЖСН бойынша жүйе мектепке дейінгі ұйымға берілген жолдама туралы мәліметтерді таппады. Сізге жеке кабинетке кіріп, мектепке дейінгі ұйымға «Жолдаманы» алу қажет.',
    gbdflButton_iinNotFound_in_voucher_3:
      'Балаңыздың көрсетілген ЖСН-і бойынша жүйеде мектепке дейінгі ұйымға берілген ваучер туралы деректер табылмады. Сізге кезек күтіп, жеке кабинеттен ваучер алуыңыз керек.',
    gbdflButton_iinNotFound_4:
      'Көрсетілген ЖСН бойынша мектепке дейінгі ұйымға жолдаманы басқа Өтініш беруші алған. Мектепке дейінгі ұйымға жолдама алған Өтініш беруші ғана баланы тіркеуге өтініш бере алады.',
    gbdflButton_iinNotFound_5:
      'Деректер табылған жоқ. ЖСН дұрыс енгізілгеніне көз жеткізіңіз немесе міндетті өрістерді толтырыңыз.',
    gbdflButton_binNotFound: 'Данных по запрашиваемому БИН не найдены',
    serviceRequest_onbeforunload: 'Сіз парақтан кеткіңіз келе ме?',
    serviceRequest_fillChildIin: 'Бала ЖСН-ін енгізу қажет!',
    serviceRequest_mustBeSixYearsOld: 'Жылдың соңында бала 6 жаста болуы керек',
    serviceRequest_alreadyStudy:
      'Оқуға түсуші {{schoolName}} білім беру ұйымында есепте тұр, "Балаларды жалпы білім беретін оқу орындары арасында ауыстыру үшін құжаттарды қабылдау" өтініш түрін таңдаңыз"',

    serviceRequestDucks_requestFailed:
      'Бұл қызмет сіздің өңіріңіз үшін қолжетімді емес. Ваучер алу үшін қолжетімді қызметті таңдаңыз.',
    serviceRequestDucks_saveSuccess: 'Сіздің өтінішіңізге қол қойылды',
    serviceRequest_age_error:
      'Ағымдағы оқу жылында баланың 6 жасқа толуына байланысты қызметті алу мүмкін емес',
    serviceRequest_queue_type_check_req_err:
      'Ошибка запроса проверки иин ребенка в очереди',
    serviceRequest_check_in_queue_err1:
      'Мемлекеттік қызметті көрсету мүмкін емес, себебі бұрын {{fio}}, ЖСН {{child_iin}} бойынша №{{req_form_id}} өтініш берілген (мәртебесі "{{app_status}}").',
    serviceRequest_check_in_queue_err2:
      'Мемлекеттік қызметті көрсету мүмкін емес, себебі {{fio}}, ЖСН {{child_iin}}  №{{req_form_id}} өтініш бойынша кезекте тұр (кезек түрі – {{queued_type}}, кезектегі басымдық – {{priority_queued}}).',
    serviceRequest_check_in_queue_err3:
      'Мемлекеттік қызметті көрсету мүмкін емес, себебі {{fio}}, ЖСН {{child_iin}}  №{{req_form_id}} өтініш бойынша {{dir_date}} жылға дейін жарамды №{{dir_id}} жолдама алды.',
    serviceRequest_check_in_queue_err4:
      'Мемлекеттік қызметті көрсету мүмкін емес, себебі №{{req_form_id}} өтініш {{deadline_stop_list}} ж. дейін тоқтату парағына жіберілді. Көрсетілген мерзім аяқталғаннан кейін {{fio}}, ЖСН {{child_iin}} кезекте қалпына келтірілетін болады.',
    serviceRequest_check_in_queue_err5:
      'Мемлекеттік қызметті көрсету мүмкін емес, себебі {{fio}}, ЖСН {{child_iin}}, №{{req_form_id}}  өтініш бойынша ваучер ұсынылған.',
    serviceRequest_check_in_queue_err6:
      'Мемлекеттік қызметті көрсету мүмкін емес, себебі {{fio}}, ЖСН {{child_iin}}, № {{req_form_id}} өтініш бойынша № {{id}} ваучер алды.',
    serviceRequest_check_in_queue_err7:
        'Мемлекеттік қызмет көрсету мүмкін емес, себебі {{fio}}, ЖСН {{child_iin}}, № {{req_form_id}} өтініш бойынша ваучер алды',
    childInformationButton_iinNotFound:
      'Деректер табылған жоқ. ЖСН дұрыс енгізілгеніне көз жеткізіңіз немесе міндетті өрістерді толтырыңыз және туу туралы куәліктің сканерленген көшірмесін қоса тіркеңіз.',
    childInformationButton_arrivedDO:
      'Мемлекеттік қызметті көрсету мүмкін емес, себебі {{fio}}, {{child_iin}} мектепке дейінгі ұйымға жолдама алды',
    childInformationButton_enrolledDO:
      'Мемлекеттік қызметті көрсету мүмкін емес, себебі {{fio}}, {{child_iin}} мектепке дейінгі ұйымда тіркелген',

    serviceRequest_supplierApplicationRequestAlreadyExists:'Жеткізушіде белсенді өтініш бар',

    serviceRequest_requesterApplicationRequestAlreadyExists:'Өтініш берушіде белсенді өтініш бар'
  }
});
